module.exports = __webpack_public_path__ + "img/telemetry_dark.9aac6287.svg";